import { FeatureList } from '../PlanTable/FeatureList'

export type AncillaryFeaturesCardLineItem =
  | {
    label: string
    value: string
  }
  | {
    label: string
    inNetworkValue: string
    outOfNetworkValue: string
  }

interface AncillaryFeaturesCardProps {
  title: string;
  lineItems: AncillaryFeaturesCardLineItem[];
}

const LineItem = ({ item }: { item: AncillaryFeaturesCardLineItem }) => {
  if ('value' in item) {
    return (
      <FeatureList>
        <FeatureList.Item
          label={item.label}
          coverage={item.value}
          topAlign
        />
      </FeatureList>
    )
  }

  if ('inNetworkValue' in item) {
    return (
      <div>
        <p className='body text-main text-nowrap pb-2'>{item.label}</p>
        <div className='pl-8'>
          <FeatureList>
            <FeatureList.Item
              label='In-network'
              coverage={item.inNetworkValue}
              topAlign
            />
            <FeatureList.Item
              label='Out-of-network'
              coverage={item.outOfNetworkValue}
              topAlign
            />
          </FeatureList>
        </div>
      </div>
    )
  }

  return null
}

export function AncillaryFeaturesCard ({
  title,
  lineItems,
}: AncillaryFeaturesCardProps) {
  return (
    <div className='w-full border border-gray-200 rounded-2xl p-4'>
      <p className='body-sm text-gray-500 pb-3'>{title}</p>
      <div className='flex flex-col gap-2'>
        {lineItems.map((lineItem) => (
          <LineItem key={lineItem.label} item={lineItem} />
        ))}
      </div>
    </div>
  )
}
